import { useCollaborations } from '@/hooks/useCollaborations'
import { Collaboration } from '@/redux/collaborationsApi'
import { Link, useNavigate } from 'react-router-dom'
import { ArrowLeft, Clock, RefreshCw } from 'lucide-react'
import { Card } from '@/components/ui/card'
const PendingContent = () => {
  const navigate = useNavigate()
  const { collaborations, refetch: refreshCampaigns } = useCollaborations()

  // Filter for pending collaborations
  const pendingCollaborations = collaborations.filter((collaboration) =>
    collaboration.milestones?.some((m) => m.status === 'submitted'),
  )

  return (
    <div className="pb-4 max-w-full">
      <button
        onClick={() => navigate('/')}
        className="text-gray-300 hover:text-white inline-flex items-center gap-2 text-sm mb-4"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Dashboard
      </button>
      <div className="mb-4 md:mb-6 flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-white">Pending Approval</h1>
          <p className="text-gray-400">Content waiting for creative finalization</p>
        </div>
        <button
          onClick={() => refreshCampaigns()}
          className="text-[#C0FD72] hover:text-[#d2ff9c] flex items-center justify-center w-8 h-8 rounded-full"
        ></button>
      </div>

      {pendingCollaborations.length > 0 ? (
        <div className="space-y-4">
          {pendingCollaborations.map((collaboration) => (
            <Card key={collaboration.id} variant="dark" className="overflow-hidden card-hover">
              <div className="p-4">
                <div className="flex items-start gap-4">
                  <div className="h-12 w-12 shrink-0 rounded overflow-hidden bg-white/20">
                    <img
                      src={collaboration.brand.logo}
                      alt={collaboration.brand.name}
                      className="h-full w-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between">
                      <div className="max-w-[60%]">
                        <Link to={`/collaborations/${collaboration.id}`}>
                          <h3 className="text-lg font-medium text-white truncate hover:text-[#C0FD72]">
                            {collaboration.title}
                          </h3>
                        </Link>
                        <p className="text-sm text-gray-400 truncate">
                          {collaboration.brand.name} •{' '}
                          {Array.isArray(collaboration.platform)
                            ? collaboration.platform.join(', ')
                            : collaboration.platform}
                        </p>
                      </div>
                      <div className="flex items-center gap-1 px-3 py-1 bg-orange-900/50 text-orange-200 rounded-full text-xs font-medium border border-orange-700/50">
                        <Clock className="h-3 w-3" />
                        <span>In Review</span>
                      </div>
                    </div>
                    <div className="mt-2 text-sm">
                      <p className="text-gray-400">
                        Submitted: {new Date(collaboration.submittedAt || '').toLocaleDateString()}
                      </p>
                      <div className="mt-1">
                        <p className="text-[#C0FD72]">We're finalizing your creative assets...</p>
                        <div className="mt-2 flex items-center">
                          <div className="w-full bg-white/10 rounded-full h-1.5">
                            <div className="bg-[#C0FD72] h-1.5 rounded-full w-2/3"></div>
                          </div>
                          <span className="text-xs text-gray-400 ml-2">67%</span>
                        </div>
                      </div>
                    </div>

                    <div className="mt-3 pt-3 border-t border-white/10 flex justify-between items-center">
                      <p className="text-xs text-gray-400">
                        You'll be notified when your final video is ready
                      </p>
                      <Link
                        to={`/collaborations/${collaboration.id}/final`}
                        className="text-sm font-medium text-[#C0FD72] hover:text-[#d2ff9c]"
                      >
                        Status Page
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      ) : (
        <Card variant="dark" className="p-8 text-center">
          <Clock className="h-12 w-12 mx-auto text-orange-400 mb-4" />
          <h2 className="text-xl font-semibold mb-2 text-white">No Pending Content</h2>
          <p className="text-gray-400">
            You don't have any content in the review process right now.
          </p>
        </Card>
      )}
    </div>
  )
}
export default PendingContent
